export const LIST_SEARCH_DEBOUNCE_MS = 700;
